import { __decorate } from "tslib";
import { SerializableObject } from '@openhps/core';
import { StereoImageFrame } from './StereoImageFrame';
let StereoVideoFrame = class StereoVideoFrame extends StereoImageFrame {
};
StereoVideoFrame = __decorate([
    SerializableObject()
], StereoVideoFrame);
export { StereoVideoFrame };
//# sourceMappingURL=StereoVideoFrame.js.map